import {
  setThemeColorFail,
  setThemeColorLoading,
  setThemeColorSuccess,
} from "store/reducers/Theme/theme";

export const setGolbalTheme = (theme) => async (dispatch) => {
  try {
    dispatch(setThemeColorLoading());
    dispatch(setThemeColorSuccess(theme));
  } catch (error) {
    console.error(error);
    dispatch(setThemeColorFail("Failed to set the theme color"));
  }
};
